import { useEffect, type FunctionComponent } from 'react';
import type { citations } from '@/features/client-onboarding/components/citations';
import { useOnboardingNavigationActions } from '@/features/client-onboarding/stores/onboarding-navigation-store';

interface SlideSetupOptions {
  slidePage: FunctionComponent<ClientIdProps>;
  nextButtonLabel: string;
  nextSlidePage?: FunctionComponent<ClientIdProps>;
  previousSlidePage?: FunctionComponent<ClientIdProps>;
  optionalCtaLabel?: string;
  optionalCtaPage?: FunctionComponent<ClientIdProps>;
  secondaryNextButtonLabel?: string;
  secondaryNextSlidePage?: FunctionComponent<ClientIdProps>;
  disableNextButton?: boolean;
  errorModalMessage?: string;
  shouldHideNextNavigation?: boolean;
  hideProgressStepper?: boolean;
  citations?: (typeof citations)['value'][];
  onNextClick?: () => void;
  onBackClick?: () => void;
}

export function useSlideSetup(options: SlideSetupOptions) {
  const { setSlideConfig } = useOnboardingNavigationActions();

  useEffect(() => {
    setSlideConfig(options);
  }, [
    options.slidePage,
    options.nextButtonLabel,
    options.nextSlidePage,
    options.previousSlidePage,
    options.optionalCtaLabel,
    options.optionalCtaPage,
    options.secondaryNextButtonLabel,
    options.secondaryNextSlidePage,
    options.disableNextButton,
    options.errorModalMessage,
    options.shouldHideNextNavigation,
    options.hideProgressStepper,
    options.onNextClick,
    options.onBackClick,
    setSlideConfig,
  ]);
}
